import React, { FC, useEffect, useState } from 'react';
import ContentLoader from 'react-content-loader';
import css from '../Question/Question.module.scss';
import color from 'styles/color.module.scss';
import { FormattedMessage } from 'react-intl';

const textHeight = 13;

export const QuestionSkeleton: FC = () => {
  const [showDelayMessage, setShowDelayMessage] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShowDelayMessage(true), 4000);
    return () => clearTimeout(t);
  }, []);

  // show loading text if loading takes a while
  // e.g. when submitting CINT form or API is under heavy load
  return (
    <article className={css.question}>
      <form className={css.content} aria-label={`instructions`}>
        <div>
          {showDelayMessage && (
            <div className={css.hero}>
              <FormattedMessage id="overview.waitMessage" defaultMessage="Just a moment" />
              {/* Bouncing dots :D */}
              <span aria-hidden="true" className={css.dotsSpringy}>
                <span>.</span>
                <span>.</span>
                <span>.</span>
              </span>
            </div>
          )}
        </div>
        <ContentLoader viewBox="0 0 380 116" backgroundColor={color.beige} foregroundColor={color.loading}>
          <rect x="0" y="12" rx="2" ry="2" width="280" height={textHeight} />
          <rect x="0" y={12 + textHeight + 4} rx="2" ry="2" width="360" height={textHeight} />
          <rect x="0" y={12 + (textHeight + 4) * 2} rx="2" ry="2" width="120" height={textHeight} />
          <rect x="0" y={12 + 40 + (textHeight + 4) * 3} rx="2" ry="2" width="240" height={textHeight} />
        </ContentLoader>
      </form>
    </article>
  );
};
